import React from 'react'
import PropTypes from "prop-types"
import { values } from 'lodash'
import { connect } from 'react-redux'
import { 
  Modal, Row, Col, Button, Glyphicon,
  Form, FormGroup, FormControl, ControlLabel, Checkbox
} from 'react-bootstrap'

import { PriceEditor } from '../components/Price'
import MarkdownField from '../lib/MarkdownField'
import CitySelector from '../cities/CitySelector'
import CommutingForm from '../routes/components/CommutingForm'

import { getTransportationLabel, getTransportationKeys, translateCity, getText } from '../lib/text.js'
import { getEmptyTransport, TransportType } from '../lib/emptyTransport.js'

type TEProps = {
  transport: TransportType,
  onChange: Object => void,
}

type MTEProps = {
  // ...TEProps,
  item: Object,
  transport: TransportType,
  onChange: (string, any) => void,
  city: any,
  time: string,
  onClose: () => void,

  // connected
  cities: Object,
}

const mapStateToProps = state => ({
  Cities: state.cities
})

const UnconnectedTransportEditor = ({ transport, onChange, city, Cities }: TEProps) => {

  const originCity = Cities[transport.originCity || "China"]

  return (
    <div>

      {/* Precio y coste */}

      <Row>
        <Col md={6}>
          <h5>{getText("Precio")}</h5>
          <PriceEditor
            price={transport.price}
            onChange={price => onChange({ ...transport, price })}
            allowExceptions={false}
          />
        </Col>
        <Col md={6}>
          <h5>{getText("Coste")}</h5>
          <PriceEditor
            price={transport.cost}
            onChange={cost => onChange({ ...transport, cost })}
            allowExceptions={false}
          />
        </Col>
      </Row>

      {/* Notas */}
      <hr />
      <Row>
        <Col md={6}>
          <MarkdownField
            label={getText("🇪🇸 Notas internas")}
            smallLabel={getText("(códigos, duración...)")}
            value={transport.notes || ""}
            onChange={notes => onChange({ ...transport, notes })}
          />
        </Col>
        <Col md={6}>
          <MarkdownField
            label={getText("🇨🇳 Notas para cliente")}
            smallLabel={getText("(app)")}
            value={transport.clientNotes || ""}
            onChange={clientNotes => onChange({ ...transport, clientNotes })}
          />
        </Col>
      </Row>

      <hr />

      <Row>
        <Col md={5}>
          <FormGroup controlId="formControlsSelect">
            <ControlLabel>{getText("Medio")}</ControlLabel>
            <FormControl
              componentClass="select"
              placeholder="select"
              value={transport.means}
              onChange={evt => onChange({ ...transport, means: evt.target.value})}
            >
              <option value="none">
                {transport.means == "none" ? getText("Seleccionar medio de transporte") : getText("No seleccionado")}
              </option>
              {
                getTransportationKeys().map(k => (
                  <option key={k} value={k}>{getTransportationLabel(k, { withIcon: true })}</option>
                ))
              }
            </FormControl>
          </FormGroup>
        </Col>
      </Row>

      <Row>
        <Col md={6}>

          <ControlLabel>Salida</ControlLabel>

          {/* Ciudad de salida */}

          <CitySelector
            inline
            cityId={transport.originCity}
            onChange={originCity => onChange({ ...transport, originCity, departureStationKey: null, departureStationCustom: "" })}
            countryLabel={getText("País de origen")}
            cityLabel={getText("Ciudad de origen")}
          />

          {/* Dirección de origen */}
          {/* #TODO duplicado con Llegada */}

          <Row>
            <Col md={5}>
              <FormGroup controlId="formControlsSelect">
                <ControlLabel>{getText("Dirección de origen")}</ControlLabel>
                <FormControl
                  componentClass="select"
                  placeholder="select"
                  value={transport.departureStationKey || "none"}
                  onChange={evt => {
                    const departureStationKey = evt.target.value == "none" ? null : evt.target.value
                    onChange({ ...transport, departureStationKey })
                  }}
                >
                  <option value="none">
                    {getText("Introducir a mano")}
                  </option>
                  {
                    values(originCity.stations).map(({key, name, address}) => (
                      <option key={key} value={key}>{name} ({address})</option>
                    ))
                  }
                </FormControl>
              </FormGroup>
            </Col>
            <Col md={7}>
              <FormGroup>
                <ControlLabel>{""}</ControlLabel>
                <FormControl
                  style={{ marginTop: 4 }}
                  disabled={!!transport.departureStationKey}
                  value={
                    transport.departureStationKey
                      ? originCity.stations[transport.departureStationKey].address
                      : transport.departureStationCustom
                  }
                  onChange={evt => {
                    onChange({ ...transport, departureStationCustom: evt.target.value })
                  }}
                />
              </FormGroup>
            </Col>
          </Row>

          <CommutingForm
            item={transport.commuteTo || {}}
            onChange={(k, v) => onChange({ ...transport, commuteTo: { ...transport.commuteTo, [k]: v }})}
          />

        </Col>

        <Col md={6}>

          {/* Dirección de llegada */}

          <ControlLabel>Llegada</ControlLabel>

          <CitySelector
            inline
            cityId={city._id}
            disabled
            countryLabel={getText("País de destino")}
            cityLabel={getText("Ciudad de destino")}
          />

          <Row>
            <Col md={5}>
              <FormGroup controlId="formControlsSelect">
                <ControlLabel>{getText("Dirección de llegada")}</ControlLabel>
                <FormControl
                  componentClass="select"
                  placeholder="select"
                  value={transport.arrivalStationKey || "none"}
                  onChange={evt => {
                    const arrivalStationKey = evt.target.value == "none" ? null : evt.target.value
                    onChange({ ...transport, arrivalStationKey })
                  }}
                >
                  <option value="none">
                    {getText("Introducir a mano")}
                  </option>
                  {
                    values(city.stations).map(({key, name, address}) => (
                      <option key={key} value={key}>{name} ({address})</option>
                    ))
                  }
                </FormControl>
              </FormGroup>
            </Col>
            <Col md={7}>
              <FormGroup>
                <ControlLabel>{""}</ControlLabel>
                <FormControl
                  style={{ marginTop: 4 }}
                  disabled={!!transport.arrivalStationKey}
                  value={
                    transport.arrivalStationKey
                      ? city.stations[transport.arrivalStationKey].address
                      : transport.arrivalStationCustom
                  }
                  onChange={evt => {
                    onChange({ ...transport, arrivalStationCustom: evt.target.value })
                  }}
                />
              </FormGroup>
            </Col>
          </Row>

          {/* Checkbox para ir al hotel a dejar maletas */}

          <div style={{ marginLeft: 5 }}>
            <Checkbox
              checked={!!transport.shouldGoToHotelFirst}
              onChange={evt => onChange({ ...transport, shouldGoToHotelFirst: evt.target.checked })}
            >
              {getText("All llegar, ir al hotel a por las maletas")}
            </Checkbox>
          </div>

          {
            transport.shouldGoToHotelFirst && (
              <CommutingForm
                item={transport.commuteFrom || {}}
                onChange={(k, v) => onChange({ ...transport, commuteFrom: { ...transport.commuteFrom, [k]: v }})}
              />
            )
          }

        </Col>
      </Row>

    </div>
  )
}

export const TransportEditor = connect(mapStateToProps)(UnconnectedTransportEditor)

export const TransportItemEditor = ({ item, transport, onChange, time, onClose, city }: MTEProps) => (
  <Modal show bsSize="large" onHide={() => onClose()}>
    <Modal.Header>
      <Modal.Title>
        {`${getText("transporte_a_1")}${translateCity(city)}${getText("transporte_a_2")}`}
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>

      <Form inline style={{marginTop: 15, marginBottom: 15}}>
        <FormGroup>
          <ControlLabel style={{marginRight: 10}}>{getText("Horario")}</ControlLabel>
          <FormControl
            style={{maxWidth: 200}}
            value={time}
            onChange={evt => onChange("time", evt.target.value)}
          />
        </FormGroup>

        <Checkbox
          style={{marginTop: 15, display: "block"}}
          checked={!!item.useCustomFee}
          onChange={evt => onChange("useCustomFee", evt.target.checked)}
        >
          {"  " + getText("Cambiar gastos de gestión (sólo para este ítem)")}
        </Checkbox>

        {
          item.useCustomFee && (
            <FormGroup style={{display: "block"}}>
              <ControlLabel>{getText("Nuevo % gestión")}</ControlLabel>
              <FormControl
                style={{marginLeft: 10}}
                type="number"
                value={item.customFee || 0}
                onChange={evt => onChange("customFee", parseInt(evt.target.value))}
              />
            </FormGroup>
          )
        }

      </Form>

      <TransportEditor
        transport={transport}
        city={city}
        onChange={x => onChange("transport", x)}
      />

    </Modal.Body>
    <Modal.Footer>
      <Button onClick={() => onChange(getEmptyTransport(transport.to))}>
        <Glyphicon glyph="remove" /> {getText("Reset")}
      </Button>
      <Button bsStyle="success" onClick={() => onClose()}>
        <Glyphicon glyph="ok" /> {getText("OK")}
      </Button>
    </Modal.Footer>
  </Modal>
)
